// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".attested-by-police-icon::after,\n.attested-by-police-temporary-icon::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  display: block;\n  background-position: 50% 50%;\n  background-size: 100%;\n  background-repeat: no-repeat;\n}\n.attested-by-police-icon::after {\n  background-image: var(--image-police-active-badge);\n}\n.attested-by-police-temporary-icon::after {\n  background-image: var(--image-police-temporary-active-badge);\n}\n", ""]);
// Exports
module.exports = exports;
